import type { TFunction } from "i18next";
import type { Task } from "../../api/tasks";

/** Název úkolu: úkol „nachystat“ z ranní kontroly nese jen název položky, text doplní jazyk uživatele. */
export function taskTitle(t: TFunction, task: Pick<Task, "title" | "source" | "kind">): string {
  return task.source === "Check" && task.kind === "Prep" ? t("tasks.prepareItem", { name: task.title }) : task.title;
}

/** Komu úkol patří: osobě, oddělení, nebo nikomu („kdo dřív“). */
export function assigneeText(t: TFunction, task: Pick<Task, "assigneeUserName" | "assigneeDepartmentName">): string {
  return task.assigneeUserName ?? task.assigneeDepartmentName ?? t("tasks.unassigned");
}
